import log from 'loglevel';

/**
 * 替换console方法
 */
const replaceConsole = () => {
  window.console.log = log.info;
  window.console.debug = log.debug;
  window.console.info = log.info;
  window.console.warn = log.warn;
  window.console.error = log.error;
};

/**
 * 设置日志级别
 */
const setLogLevel = () => {
  log.setLevel(import.meta.env.VITE_APP_LOG_LEVEL ?? 'error');
};

/**
 * 初始化
 */
const init = () => {
  replaceConsole();
  setLogLevel();
};

export default init;
